import script from "./changePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./changePassword.vue?vue&type=script&setup=true&lang=js"

import "./changePassword.vue?vue&type=style&index=0&id=aaccc496&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aaccc496"]])

export default __exports__